export default __webpack_public_path__ + "static/media/geetha.77da5a15.jpg";